import React, { useState, Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import estilos from './TablaProducto.module.css';
import { v4 as uuidv4 } from 'uuid';
import Tooltip from '@mui/material/Tooltip';
import {
    Table,
    Button,
    Container,
    Modal,
    ModalHeader,
    ModalBody,
    FormGroup,
    ModalFooter,
} from "reactstrap";
import ModalCamposObligatorios from '../../App/ModalCamposObligatorios';
import moment from 'moment'
function TablaProductoIngresoMaduracion(props) {

    const { api = undefined } = props
    const marcas = props.marcas
    let fc_31IngresosMap = props.productosMap
    let otrainstalacion = props.propia
    const emicioncertificadopromocion = props.emicioncertificadopromocion
    const { handdleProductoIngreso, handdleRemoveProductosPrevIngreso, handdleEditProductosPrevIngreso, productosIngreso } = api
    // const { productosMap, handdleProductoMap } = props.MapProductos
    const [id, setId] = React.useState()
    const [numerolote, setNumeroLote] = React.useState('')
    const [fechaingreso, setfechaingreso] = React.useState('')
    const [numeroanalisis, setnumeroanalisis] = React.useState('')
    const [volumen, setVolumen] = React.useState('')
    const [contenidoalcoholico, setContenidoAlcoholico] = React.useState('')
    const [informacionadicional, setInformacionAdicional] = React.useState('')
    var fechaHoy = moment().format('YYYY-MM-DD');
    const [editar, setEditar] = React.useState(false)

    const [productoMap, setproductoMap] = React.useState()

    const [validacion, setvalidacion] = React.useState(false)
    const [texto, settexto] = React.useState('')
    const resetValores = (objectProducto) => {
        setvalidacion(objectProducto.validacion)
    }
    let columns = []

    columns = [
        {
            field: 'numerolote', headerName: 'No. de lote', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 200,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.numerolote}`} arrow>
                        <label>{`${params.row.numerolote} `}</label>
                    </Tooltip>
                </div>
            )
        },
        { field: 'fechaingreso', headerName: 'Fecha de ingreso', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 130, },

        {
            field: 'numeroanalisis', headerName: 'Numero de analisis', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 180,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.numeroanalisis}`} arrow>
                        <label>{`${params.row.numeroanalisis} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'volumen', headerName: 'Volumen (Litros)', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 150,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.volumen}`} arrow>
                        <label>{`${params.row.volumen} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'contenidoalcoholico', headerName: '% Alc. Vol.', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 150,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.contenidoalcoholico}`} arrow>
                        <label>{`${params.row.contenidoalcoholico} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'informacionadicional', headerName: 'Información Adicional', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 200,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.informacionadicional}`} arrow>
                        <label>{`${params.row.informacionadicional} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'accion', headerName: 'Acción', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 180,
            renderCell: (params) => (

                <Fragment>
                    {fc_31IngresosMap?.length > 0 ? (
                        <Fragment>

                            {/* // <button className={'btn btn-warning ms-0'} onClick={() => { botonEditar(params) }}>Editar</button> */}
                            <button className={'btn btn-danger ms-1'} onClick={() => { botonCorregir(params) }} >Corregir</button>
                        </Fragment>
                    ) : (
                        <Fragment>
                            <button className={'btn btn-warning ms-0'} onClick={() => { botonEditar(params) }}>Editar</button>
                            <button className={'btn btn-danger ms-1'} onClick={() => { botonEliminar(params) }} >Eliminar</button>
                        </Fragment>)}
                </Fragment>

            )
        },
    ]

    const botonEliminar = async (params) => {
        handdleRemoveProductosPrevIngreso({ data: params.row })
    }

    const botonGuardar = async () => {
        if (fechaingreso.toString().length > 0 && numerolote.length > 0) {
            let dato = {
                id: id, numerolote: numerolote, fechaingreso: fechaingreso, numeroanalisis: numeroanalisis,
                informacionadicional: informacionadicional, volumen: volumen, contenidoalcoholico: contenidoalcoholico
            }
            handdleEditProductosPrevIngreso(dato)
            setVolumen('')
            setContenidoAlcoholico('')
            setNumeroLote('')
            setfechaingreso('')
            setnumeroanalisis('')
            setInformacionAdicional('')
            setEditar(false)
            setproductoMap([])
        } else {
            setvalidacion(true)
        }
    }
    const botonEditar = async (params) => {
        setId(params.row.id)
        setNumeroLote(params.row.numerolote)
        setfechaingreso(params.row.fechaingreso)
        setnumeroanalisis(params.row.numeroanalisis)
        setInformacionAdicional(params.row.informacionadicional)
        setVolumen(params.row.volumen)
        setContenidoAlcoholico(params.row.contenidoalcoholico)
        setEditar(true)
    }

    let datos = []
    let [rows, setRows] = React.useState(productosIngreso)
    React.useEffect(() => {
        setRows(productosIngreso)
    }, [productosIngreso])

    const botonAgregar = async () => {
        if (fechaingreso.toString().length > 0 && numerolote.length > 0) {
            let dato = {
                id: uuidv4(), numerolote: numerolote, fechaingreso: fechaingreso, numeroanalisis: numeroanalisis,
                informacionadicional: informacionadicional, volumen: volumen, contenidoalcoholico: contenidoalcoholico
            }
            handdleProductoIngreso(dato)
            setNumeroLote('')
            setfechaingreso('')
            setnumeroanalisis('')
            setInformacionAdicional('')
            setVolumen('')
            setContenidoAlcoholico('')
        } else {
            setvalidacion(true)
        }
    }
    const botonCancelar = async () => {
        setproductoMap([])
        setNumeroLote('')
        setfechaingreso('')
        setnumeroanalisis('')
        setInformacionAdicional('')
        setVolumen('')
        setContenidoAlcoholico('')
        setEditar(false)
    }
    const botonCorregir = async (params) => {
        const filtro = fc_31IngresosMap.filter(anexo => anexo.idfc31_anexoingresomaduracion === params.row.idfc31_anexoingresomaduracion)
        setproductoMap(filtro[0])
        if (params.row.idfc31_anexoingresomaduracion) setId(params.row.idfc31_anexoingresomaduracion)
        else setId(params.row.idfc31_anexoingresomaduracion)
        setNumeroLote(params.row.numerolote)
        setfechaingreso(params.row.fechaingreso)
        setnumeroanalisis(params.row.numeroanalisis)
        setInformacionAdicional(params.row.informacionadicional)
        setVolumen(params.row.volumen)
        setContenidoAlcoholico(params.row.contenidoalcoholico)
        setEditar(true)
    }

    return (
        <>
            <FormGroup><br />
                <div className='row align-items-center'>
                    <div className='col-md-4'>
                        <div className="form-floating mb-3">
                            <input type="text" min='0' className={`form-control ${productoMap?.ingresocheck !== undefined ? (productoMap?.ingresocheck
                                ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='No. de cajas'
                                value={numerolote} onChange={e => setNumeroLote(e.target.value)}
                            />
                            <label htmlFor='floatingInput'>Número de lote</label>
                            {numerolote.length <= 0 ? <>
                                <span className='text-danger'>Campo obligatorio</span> <br /></> : ''}
                            <span className='text-danger'>{productoMap?.ingresocheck ? productoMap?.ingreso : ''}</span>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className="form-floating mb-3">
                            <input type="date" className={`form-control ${productoMap?.ingresocheck !== undefined ? (productoMap?.ingresocheck
                                ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='fechaingreso'
                                value={fechaingreso} onChange={e => setfechaingreso(e.target.value)} min={fechaHoy}
                            />
                            <label htmlFor='floatingInput'>Fecha de ingreso a maduración</label>
                        </div>
                        {fechaingreso.length <= 0 ? <>
                            <span className='text-danger'>Campo obligatorio</span><br /></> : ''}
                        <span className='text-danger'>{productoMap?.ingresocheck ? productoMap?.ingreso : ''}</span>
                    </div>
                    <div className='col-md-4'>
                        <div className="form-floating mb-2">
                            <input type="text" min='0' className={`form-control ${productoMap?.ingresocheck !== undefined ? (
                                productoMap?.ingresocheck ? 'inputDenegado' : 'inputValidado') : ('')} `}
                                id="floatingInput" placeholder='Contenido Alcohólico'
                                value={numeroanalisis} onChange={e => setnumeroanalisis(e.target.value)}
                                onWheel={event => event.currentTarget.blur()}
                            />
                            <Tooltip title={`Contenido Alcohólico`} arrow>
                                <label htmlFor='floatingInput'>Numero de análisis fisicoquímico</label>
                            </Tooltip>
                        </div>
                        {/*numeroanalisis.length <= 0 ? <>
                            <span className='text-danger'>Campo obligatorio</span> <br /></> : ''*/}
                        <span className='text-danger'>{productoMap?.ingresocheck ? productoMap?.ingreso : ''}</span>
                    </div>
                    <div className='col-md-6 mt-2'>
                        <div className="form-floating mb-3">
                            <input type="number" className={`form-control ${productoMap?.ingresocheck !== undefined ? (productoMap?.ingresocheck
                                ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='volumen'
                                value={volumen} onChange={e => setVolumen(e.target.value)}
                            />
                            <label htmlFor='floatingInput'>Volumen (Litros)</label>
                        </div>
                        <span className='text-danger'>{productoMap?.ingresocheck ? productoMap?.ingreso : ''}</span>
                    </div>
                    <div className='col-md-6 mt-2'>
                        <div className="form-floating mb-2">
                            <input type="number" min='0' className={`form-control ${productoMap?.ingresocheck !== undefined ? (
                                productoMap?.ingresocheck ? 'inputDenegado' : 'inputValidado') : ('')} `}
                                id="floatingInput" placeholder='Contenido Alcohólico'
                                value={contenidoalcoholico} onChange={e => setContenidoAlcoholico(e.target.valueAsNumber)}
                                onWheel={event => event.currentTarget.blur()}
                            />
                            <Tooltip title={`Contenido Alcohólico`} arrow>
                                <label htmlFor='floatingInput'>% Alc. Vol.</label>
                            </Tooltip>
                        </div>
                        {contenidoalcoholico < 35 || contenidoalcoholico > 55 ?
                            <span className='text-danger'>El rango debe de ser de 35% a 55%</span> : ''
                        }
                        {/*contenidoalcoholico.length <= 0 ? <>
                            <span className='text-danger'>Campo obligatorio</span> <br /></> : ''*/}
                        <span className='text-danger'>{productoMap?.ingresocheck ? productoMap?.ingreso : ''}</span>
                    </div>
                    <div className='col-md-12'><br />
                        <div className="form-floating mb-3">
                            <input type="text" className={`form-control ${productoMap?.ingresocheck !== undefined ? (productoMap?.ingresocheck
                                ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='Contenido neto x botella'
                                value={informacionadicional} onChange={e => setInformacionAdicional(e.target.value)}
                                onWheel={event => event.currentTarget.blur()}
                            />
                            <label htmlFor='floatingInput'>Información adicional</label>
                            {/*informacionadicional.length <= 0 ? <>
                                <span className='text-danger'>Campo obligatorio</span> <br /></> : ''*/}
                            <span className='text-danger'>{productoMap?.ingresocheck ? productoMap?.ingreso : ''}</span>
                        </div>
                    </div>
                </div>
            </FormGroup>
            {!editar ?
                <Fragment>
                    {fc_31IngresosMap?.length === 0 ? (
                        <Fragment>
                            <div className='col-md-3'></div>
                            <div className='text-center'>
                                <button className='btn btn-success col-md-3' onClick={botonAgregar}>Agregar producto</button>
                            </div>
                            <br />
                        </Fragment>) : ''}
                </Fragment>
                : (
                    <Fragment>
                        <div className='row'>
                            <div className='col-md-3'></div>
                            <button className={'btn btn-success col-md-3 ms-0'} onClick={botonGuardar}>Guardar producto</button>
                            <button className={'btn btn-dark col-md-3 ms-2'} onClick={botonCancelar}>Cancelar</button>
                        </div>
                        <br />
                    </Fragment>
                )}
            <br />
            <hr />
            {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
            <div className='row justify-content-center'>
                <div className='col-12'>
                    <div style={{ height: (130 + (rows?.length * 50)), width: '100%', color: 'black' }}>
                        <DataGrid
                            rows={rows}
                            columns={columns}

                            sx={{
                                boxShadow: 0,
                                color: 'black',
                                border: 0,
                                '& .MuiDataGrid-cell': {
                                    display: 'block',
                                    position: 'relative',
                                    textAlign: 'center',
                                },
                            }}
                        />
                    </div>
                </div>
            </div>

        </>
    )

}
export default TablaProductoIngresoMaduracion